import styled from 'styled-components';
import { Button, Form, Input } from 'antd';

export const SigninDiv = styled.div`
  margin: 0px auto;
  width: 100%;
  height: 100vh;
  background-color: #F5F4F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StyledLogo = styled.div`
  width: 217px;
  height: 46.7px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('/assets/logo.png');
  background-size: cover;
  margin-bottom: 2vw;
  ${({ theme }) =>
    theme.media.monitor(
      `
        width: 11.42vw;
        height: 2.46vw;
    `,
    )}
`;

export const StyledForm = styled(Form)`
  width: 436px;
  height: 399px;
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
  justify-content: center;
  align-items: center;
`;

export const StyledFormItem = styled(Form.Item)<{browserSafariType:boolean}>`
  width: 100%;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0px;
  label {
    font-family: 'Suit bold', 'Inter bold';
    font-weight: ${(props) => props.browserSafariType ? 500 : 700};
    font-size: 18px;
    line-height: 22px;
    color: 'rgba(38, 38, 38, 1)';
  }
`;

export const StyledInput = styled(Input)`
  width: 356px;
  height: 46px;
  border-radius: 4px;
  border-color: #CAC9CC;
  input {
    font-family: 'Suit regular', 'Inter regular';
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #262626;
  }
  
  input::placeholder {
    color: #979799;  
    font-family: 'Suit regular', 'Inter regular';
  }
`;

export const StyledFindGroup = styled.div`
  color: rgba(151, 151, 153, 1);
  font-family: 'Suit regular', 'Inter regular';
  font-weight: 400;
  font-size: 14px;
  text-decoration: underline; 
  text-decoration-color: rgba(151, 151, 153, 1); 
  text-decoration-thickness: 1px; 
  text-underline-offset : 2px;
  text-decoration-skip-ink: all;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;
`

export const StyledButton = styled(Button)<{check: boolean}>`
  margin-top: 20px;
  width: 356px;
  height: 52px;
  background-color: ${(props) => props.check ? 'rgba(90, 30, 219, 1)' : 'rgba(151, 151, 153, 1)'};
  color: white !important;
  border-radius: 5px;
  margin-bottom: 5px;
  font-family: 'Suit bold';
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: white !important;
  }
  &:hover {
    background-color: #5A1EDB !important;
  }
`;

export const ErrorMessge = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(253, 51, 38, 1);
  font-weight: 500;
  font-size: 13px;
  margin-bottom: -10px;
`;